/**
 * DemoNotice — subtle, professional strip that discloses YugOS is a
 * demonstration deployment. Rendered on the Login page and in the site
 * footer. Kept intentionally unobtrusive: single line of muted text on
 * a soft amber background, never blocks a primary action.
 *
 * `variant="light"` (default) — for light surfaces (login card, page footer)
 * `variant="dark"`             — for dark surfaces (landing footer meta)
 */
import React from "react";
import { AlertTriangle } from "lucide-react";

const COPY =
    "YugOS is currently available as a demonstration platform. Data entered may be periodically reset. Please do not upload confidential or sensitive business information.";

export default function DemoNotice({ variant = "light", className = "" }) {
    const isDark = variant === "dark";
    return (
        <div
            data-testid="demo-notice"
            role="note"
            className={
                "flex items-start gap-2 rounded-md border px-3 py-2 text-[11.5px] leading-[1.5] " +
                (isDark
                    ? "border-amber-500/25 bg-amber-500/[0.06] text-amber-200/90 "
                    : "border-amber-200 bg-amber-50 text-amber-900 ") +
                className
            }
        >
            <AlertTriangle
                className={
                    "mt-[1px] h-3.5 w-3.5 shrink-0 " +
                    (isDark ? "text-amber-300" : "text-amber-600")
                }
                strokeWidth={1.75}
            />
            <span>{COPY}</span>
        </div>
    );
}
